<div class="row">
  <mat-form-field class="col-3">
    <input #vf0
           matInput
           type="tel"
           [(ngModel)]="verificationCode0"
           autocomplete="off"
           maxlength="1"
           (keyup)="focusNext(0, $event)"/>
  </mat-form-field>
  <mat-form-field class="col-3">
    <input #vf1
           matInput
           type="tel"
           [(ngModel)]="verificationCode1"
           autocomplete="off"
           maxlength="1"
           (keyup)="focusNext(1, $event)" />
  </mat-form-field>
  <mat-form-field class="col-3">
    <input #vf2
           matInput
           type="tel"
           [(ngModel)]="verificationCode2"
           autocomplete="off"
           maxlength="1"
           (keyup)="focusNext(2, $event)" />
  </mat-form-field>
  <mat-form-field class="col-3">
    <input #vf3
           matInput
           type="tel"
           [(ngModel)]="verificationCode3"
           autocomplete="off"
           maxlength="1"
           (keyup)="focusNext(3, $event)" />
  </mat-form-field>
</div>
